
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Grid } from '@mui/material'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import CheckboxField from 'components/atoms/fields/CheckboxField'
import DatePickerField from 'components/atoms/fields/DatePickerField'
import InputField from 'components/atoms/fields/InputField'
import SelectField from 'components/atoms/fields/SelectField'

import formModel, { initialValues } from 'utils/formModels/special/amendIEPModel'
import { crudColorMap, crudIconMap } from 'utils/helpers'

import { ActionType, IParticipant } from 'types'
import { ScrollToError } from 'components/atoms/ScrollToError'

interface IProps {
  action: ActionType
  id: string
  viewOnly: boolean
  tabText?: string
  tabKey?: string
}

const AmendIEPForm: FC<IProps> = ({ action, id, viewOnly }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
 
  const {
    description,
    done
  } = formModel()

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values: any) => {
      }}
    >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form>
            <ScrollToError/>
            <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
                
              <Grid item xs={12}>
                <InputField multiline={true} fieldProps={{ ...description }}  />
              </Grid>
              <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
                 <CheckboxField fieldProps={{ ...done }} />
              </Grid>

              <Grid item xs={12}>
                <SubmitButton
                    color={crudColorMap[action]}
                    text={`Save`}
                    icon={crudIconMap[action]}
                    sx={{ width: '10rem' }}
                    isLoading={false}
                />
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}

export default AmendIEPForm
